import { render, staticRenderFns } from "./ItemKapufaStrand.vue?vue&type=template&id=3cacb6a9&scoped=true&"
import script from "./ItemKapufaStrand.vue?vue&type=script&lang=js&"
export * from "./ItemKapufaStrand.vue?vue&type=script&lang=js&"
import style0 from "./ItemKapufaStrand.vue?vue&type=style&index=0&id=3cacb6a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cacb6a9",
  null
  
)

export default component.exports